function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.5 12.5524H13.5V15.5314H16.5V12.5524Z",
  fill: "#6F62FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 0L23.5605 11.4798C24.1465 12.0617 24.1465 13.0043 23.5605 13.5861C23.2676 13.8771 22.8838 14.0225 22.5 14.0225C22.1162 14.0225 21.7324 13.8771 21.4395 13.5861L21 13.1497V20H3V13.1497L2.56055 13.5861C1.97461 14.168 1.02539 14.168 0.439453 13.5861C-0.146484 13.0043 -0.146484 12.0617 0.439453 11.4798L12 0ZM10.5 18.5105H19.5V11.6602L12 4.21257L4.5 11.6602V18.5105H7.5V12.5524H10.5V18.5105Z",
  fill: "#6F62FF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.5 0.636123V2.3623L4.5 5.34136V0.636123H7.5Z",
  fill: "#6F62FF"
});

var SvgOwnership = function SvgOwnership(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 30 18",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOwnership, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ownership.ecb13f68.svg";
export { ForwardRef as ReactComponent };